const __vite_glob_0_6 = "/* document header */\n.light-mode .t-doc__header,\n.dark-mode .t-doc__header {\n  --scalar-header-background-1: var(--scalar-background-1);\n  --scalar-header-border-color: var(--scalar-border-color);\n  --scalar-header-color-1: var(--scalar-color-1);\n  --scalar-header-color-2: var(--scalar-color-2);\n  --scalar-header-background-toggle: var(--scalar-color-3);\n  --scalar-header-call-to-action-color: var(--scalar-color-accent);\n}\n";
export {
  __vite_glob_0_6 as default
};
//# sourceMappingURL=moon.css.js.map
